export default __webpack_public_path__ + "static/media/smileFour.338b6f20.svg";